import { Component, inject } from '@angular/core';
import { UpsellCardComponent } from '@components/upsell-card/upsell-card.component';
import { QuestionnaireAnswers } from '@enums/questionnaire-answers';
import { UpsellSlugs } from '@enums/upsell-slugs';
import { SelectableOption } from '@models/selectable-option';
import { ConsultationStorageService } from '@services/consultation-storage.service';

@Component({
  selector: 'app-maximize-your-glp-1-results',
  imports: [UpsellCardComponent],
  templateUrl: './maximize-your-glp-1-results.component.html',
  styleUrl: './maximize-your-glp-1-results.component.scss',
})
export class MaximizeYourGlp1ResultsComponent {
  public readonly slug: UpsellSlugs = UpsellSlugs.Glp1Booster;
  public readonly options: SelectableOption[] = [
    new SelectableOption('Yes, add the GLP-1 Booster to my plan', this.slug),
    new SelectableOption("No, I don't want to include the GLP-1 Booster", QuestionnaireAnswers.No),
  ];

  private consultationStorageService = inject(ConsultationStorageService);

  /**
   * Store the address form in the local storage service using the current upsell option value.
   */
  public onContinueButtonPressed(optionSelected: string): void {
    this.consultationStorageService.setUpsellAddress(
      this.slug,
      optionSelected === QuestionnaireAnswers.No ? null : this.consultationStorageService.address,
    );
  }
}
